















































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import ListViewItem from "list-view/src/listviewitem";
import NewsModel from "@views/a-model/news-model";
import DefaultModel from "@views/a-model/default-model";
import EnumNewsType from "../../dataSource/api/RunPay/DataModels/Enums/EnumNewsType";
import ControlValidatorGroupComponent from "../components/control-validator-group.vue";
import iMobileDeviceUser from "../a-model/interfaces/iMobileDeviceUser";
import EnumMobileRoles from "../../dataSource/api/RunPay/Admin/IServices/Enums/EnumMobileRoles";
import DeviceModel from "../a-model/devce-model";
import UserAddTerminalActionRequest from "../../dataSource/api/RunPay/Admin/IServices/Models/UserMobile/UserAddTerminalActionRequest";
import UserDeviceItemResponse from "@dataSource/api/RunPay/Admin/IServices/Models/UserMobile/UserDeviceItemResponse";

@Component({
  name: "mobile-users",
  components: {}
})
export default class MobileUsersComponent extends Vue {
  roles: ListViewItem<DefaultModel>[] = [];
  currentRolles: number[] = [];
  currentUserId: String = null;
  userId: String = null;
  userName: String = "";
  pageSize = 10;
  currentPage = 1;
  totalItems = 5;
  select = true;
  modalWindowTitle = "";
  modalWindowShow = false;
  modalWindowLinkShow = false;
  terminaleCode = "";

  linkedDevices: UserDeviceItemResponse[] = [
    { Id: "1", IsVerified: true },
    { Id: "2", IsVerified: false }
  ];
  devices: ListViewItem<DeviceModel>[] = [];

  // userRoles: ListViewItem<DefaultModel>[] = [];

  search = "";
  Items: iMobileDeviceUser[] = [];
  innerItems: iMobileDeviceUser[] = [];

  isLoading = false;
  created() {
    document.title = this.$route.meta.title;
    this.getRolesInit();
    this.getUsers({ Take: this.pageSize, Skip: 0 });
  }

  setCurent(id: string, roles: number[]) {
    this.currentUserId = id;
    this.currentRolles = roles;
    this.getUserRoles(roles); // получть роли и заполнить dropDown
  }

  // OnChangeRoles(){

  // }

  onChageRoles(selected: ListViewItem<DefaultModel>[]) {
    // if (selected == undefined) {
    //   this.currentUserId = null;
    //   this.currentRolles = [];
    //   return;
    // }
    // var element = this.innerItems.find(
    //   item => item.id == this.currentUserId.toString()
    // );
    // if (selected[0].Value.id != element.role) {
    //    this.innerItems.find(item=>item.id==this.currentUserId.toString()).role=selected[0].Value.id;
    //   // this.setUserRolle(this.currentUserId.toString(), selected[0].Value.id);
    // }
    // this.currentRolles = [];
    // this.currentUserId = null;
    // this.getUsers({ Take: this.pageSize, Skip: this.currentPage });
  }

  onClickRolle(value: any) {
    this.currentUserId = null;
    this.currentRolles = [];
  }

  closeModalWindow() {
    this.modalWindowShow = false;
    this.userId = null;
  }
  closeModalWindowLink() {
    this.modalWindowLinkShow = false;
    this.userId = null;
  }

  onOpenWindowConnectDeviceToUser(userId: string, userName: string) {
    // this.getRolesDD();
    this.roles.forEach(item => {
      item.Selected = false;
    }); // очистка выбранных ролей
    this.devices = [];
    this.userId = userId;
    this.userName = userName;
    this.getTerminale(this.userId.toString(), "");
    this.modalWindowShow = true;
  }

  onConnectDeviceToUser() {
    const selectedDevices = this.devices.filter(el => el.Selected == true);
    if (selectedDevices.length > 0) {
      const roles = this.roles
        .filter(item => item.Selected == true)
        .map(el => el.Value.id);
      if (selectedDevices.length == 1) {
        this.connectTerminale(
          this.userId.toString(),
          selectedDevices[0].Value.id,
          roles
        );
      } else {
        const devicesId = selectedDevices.map(item => item.Value.id);
        this.connectTerminales(this.userId.toString(), devicesId, roles);
      }
      this.closeModalWindow();
    } else {
      this.$dialog.alert(this.$locale.getTranslate("selectDevice"));
    }
  }

  onDeleteItem(el: ListViewItem<DeviceModel>) {
    // this.userRoles.splice(this.userRoles.findIndex(item=>item.Value.id == el.Value.id),1)
    this.roles.find(item => item.Value.id == el.Value.id).Selected = false;
  }

  onDeleteDevice() {
    const sele = this.devices.filter(item => item.Selected == true);

    if (sele.length == 0) {
      this.roles.forEach(items => (items.Selected = false));
      return;
    }
  }

  onChangeDevice(items: ListViewItem<DeviceModel>[]) {
    //обновить роли если не определены ьл вывести все
    const deviceRoles =
      items[0].Value.roles == null ? [] : items[0].Value.roles;
    // this.changeRoles = deviceRoles.length>0;
    // this.roles=[]
    if (deviceRoles.length == 0) {
      this.roles.forEach(element => {
        element.Selected = false;
      });
    } else {
      this.roles.forEach(element => {
        element.Selected = deviceRoles.includes(element.Value.id);
      });
    }

    // this.roles = this.userRoles
  }

  changeAutocomlite(serchTermit: string) {
    this.getTerminale(this.userId.toString(), serchTermit);
  }

  /*
    проверяем терминал на существование
  */
  getTerminale(terminaleCode: string, search: string): Boolean {
    this.$api.UserMobileService.GetTerminalsForAddingEvent.once(response => {
      if (!response.IsSuccess) {
        return false;
      }
      const temp = this.devices.filter(item => item.Selected == true);
      this.devices = temp;
      // temp.forEach(item=>{this.devices.push(item)})
      // console.log("выбранный элемент", temp);
      response.Value.forEach(element => {
        if (this.devices.findIndex(el => el.Value.id == element.Id) == -1) {
          this.devices.push(
            new ListViewItem(
              new DeviceModel(
                element.Id,
                element.Code.toString(),
                element.OccupiedRoles
              ),
              false,
              false
            )
          );
        }
      });
    });
    this.$api.UserMobileService.GetTerminalsForAdding({
      UserId: parseInt(this.userId.toString()),
      Search: search,
      Take: 30
    });
    return true;
  }

  /*
    подключаем терминал
  */
  connectTerminale(userId: string, terminaleCode: string, rolles: number[]) {
    if (rolles == null) rolles = [];
    this.$api.UserMobileService.AddTerminalToUserEvent.once(response => {
      if (!response.IsSuccess) {
        this.$dialog.alert(this.$locale.getTranslate(""));
        return;
      }
      this.$dialog.success(
        this.$locale.getTranslate("deviceAddedSuccessfully")
      );
      this.devices = [];

      // this.getTerminale(this.userId.toString(), "");
    });
    this.$api.UserMobileService.AddTerminalToUser({
      UserId: parseInt(userId),
      TerminalId: parseInt(terminaleCode),
      Roles: rolles
    });
  }
  tempArray: UserAddTerminalActionRequest[];
  connectTerminales(userId: string, terminaleCode: string[], rolles: number[]) {
    if (rolles == null) rolles = [];
    this.$api.UserMobileService.AddTerminalsToUserEvent.once(response => {
      if (!response.IsSuccess) {
        this.$dialog.alert(this.$locale.getTranslate(""));
        return;
      }
      this.$dialog.success(
        this.$locale.getTranslate("deviceAddedSuccessfully")
      );
      this.devices = [];

      // this.getTerminale(this.userId.toString(), "");
    });
    this.tempArray = [];
    terminaleCode.forEach(item => {
      this.tempArray.push({
        UserId: parseInt(userId),
        TerminalId: parseInt(item),
        Roles: rolles
      });
    });

    this.$api.UserMobileService.AddTerminalsToUser({
      UserId: parseInt(userId),
      AddRequests: this.tempArray
    });
  }

  // setUserRolle(userId: string, rolleId: number) {
  //   this.$api.UserMobileService.ChangeUserRoleEvent.once(response => {
  //     if (!response.IsSuccess) {
  //       return;
  //     }
  //     this.innerItems.find(item => item.id == userId).role = rolleId;
  //     // this.$dialog.success("Роль обновлена!")
  //   });
  //   this.$api.UserMobileService.ChangeUserRole({
  //     UserId: parseInt(userId),
  //     Roles: rolleId
  //   });
  // }

  getUserRoles(selectedItem: number[]) {
    if (selectedItem == null) {
      this.roles.forEach(item => (item.Selected = false));
    } else
      this.roles.forEach(
        item => (item.Selected = selectedItem.includes(item.Value.id))
      );
  }

  getUsers({ Skip, Take }: { Skip: number; Take: number }) {
    this.$api.UserMobileService.GetPaginatedUsersListEvent.once(response => {
      this.isLoading = false;
      if (!response.IsSuccess) {
        return;
      }
      this.totalItems = response.Value.Count;
      this.innerItems = response.Value.Items.map(item => ({
        id: item.UserId.toString(),
        name: item.Name == null ? "" : item.Name.toString(),
        email: item.Email == null ? "" : item.Email.toString(),
        dateCreate: item.Date,
        roles: item.Roles != null ? item.Roles : [],
        linkedDevices: item.LinkedDevices
      }));
    });

    this.isLoading = true;
    this.$api.UserMobileService.GetPaginatedUsersList({
      Search: this.search,
      Skip: Skip,
      Take: Take
    });
  }

  isValid(): boolean {
    // if(this.fileZip==null && (!this.addingNews===undefined) &&!this.addingNews.folderName.startsWith("http")){
    //   this.zipAlert=true;
    // }

    // if(this.file==null){
    //   this.imageAlert=true;
    // }
    // else this.imageAlert=false
    // return ((this.$refs.validator as ControlValidatorGroupComponent).isValid() && !this.zipAlert && !this.imageAlert);
    return true;
  }

  getRoles(roles: number[]) {
    if (roles == null) return "Роль не задана";
    let allChangedRoles = "";
    for (let i = 0; i < roles.length; i++) {
      switch (roles[i]) {
        case 1:
          allChangedRoles += "RegionalManager ";
          break;
        case 2:
          allChangedRoles += "Engineer ";
          break;
        case 3:
          allChangedRoles += "Сollector ";
          break;
        default:
          break;
      }
    }
    return allChangedRoles;
  }

  getRolesInit() {
    this.roles = [];
    this.roles.push(
      new ListViewItem(new DefaultModel(1, "RegionalManager"), false, false)
    );
    this.roles.push(
      new ListViewItem(new DefaultModel(2, "Engineer"), false, false)
    );
    this.roles.push(
      new ListViewItem(new DefaultModel(3, "Сollector"), false, false)
    );
  }

  onSearch() {
    this.getUsers({ Take: this.pageSize, Skip: 0 });
  }

  onPaginationChanged(request: { Page: number; CountOnPage: number }) {
    this.currentPage = request.Page;
    this.getUsers({
      Skip: (request.Page - 1) * request.CountOnPage,
      Take: request.CountOnPage
    });
  }

  /**
   * Сортировка таблицы по имени полю и направлению(0,1)
   */
  onSort(sortName: string, sortType: string) {
    // console.log("sortName",sortName," sortType:",sortType)
    switch (sortName) {
      case "id":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.id > b.id ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.id < b.id ? 1 : -1;
          });
          break;
        }
      case "name":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.name > b.name ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.name < b.name ? 1 : -1;
          });
          break;
        }
      case "email":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.email > b.email ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.email < b.email ? 1 : -1;
          });
          break;
        }
      case "dateReg":
        if (sortType == "1") {
          this.innerItems.sort(function(a, b) {
            return a.dateCreate > b.dateCreate ? 1 : -1;
          });
          break;
        } else {
          this.innerItems.sort(function(a, b) {
            return a.dateCreate < b.dateCreate ? 1 : -1;
          });
          break;
        }
      default:
        break;
    }
  }
  onChangeUser(userId: string) {
    this.$router.push({ path: `mobile-users-devices/${userId}` });
  }
  async removeLinkedDevice(id: string) {
    this.modalWindowLinkShow = true;
    // this.$api.UserMobileService.SetDeviceVerification;
    const element = this.innerItems.find(el => el.id === id);
    this.linkedDevices = element.linkedDevices;
    // var res = await this.$dialog
    //   .confirm(
    //     this.$locale.getTranslate("Отвязать пользователя от устройства?")
    //   )
    //   .then((res: boolean) => {
    //     return res;
    //   });
    // if (!res) {
    //   return;
    // }
    //   this.$api.UserMobileService.RemoveLinkWithDeviceEvent.once(response => {
    //     if (!response.ErrorMessage) {
    //       this.$notification.error(response.ErrorMessage);
    //       return;
    //     }
    //   });
    //   this.$api.UserMobileService.RemoveLinkWithDevice(id);
  }
  onActivelinkDev(id: string, value: boolean) {
    const element = this.linkedDevices.filter(el => el.Id == id)[0];
    if (element.IsVerified == value) {
      return;
    }
    this.linkedDevices.filter(el => el.Id == id)[0].IsVerified = value;
    this.$api.UserMobileService.SetDeviceVerificationEvent.once(response => {
      if (!response.IsSuccess) {
        this.$notification.error(response.ErrorMessage);
        return;
      }
    });
    this.$api.UserMobileService.SetDeviceVerification({
      Id: id,
      IsVerified: value
    });
    console.log(id);
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/pages/page-mobile-users.vue